import Axios from '../baseApi';

export default {
  copy(deliveryProgramId) {
    return Axios.post('/api-article/delivery-program/v1/copy', {deliveryProgramId});
  },
  async fetch() {
    return await  Axios.get('/api-article/delivery-program/v1');
  },
  async fetchById(id) {
    return await  Axios.get(`/api-article/delivery-program/v1/${id}`);
  },
  async insert(form) {
    return await  Axios.put(`/api-article/delivery-program/v1/`, form);
  },
  async update(form) {
    return await  Axios.post(`/api-article/delivery-program/v1/`, form);
  },
  async delete(id) {
    return await  Axios.delete(`/api-article/delivery-program/v1/${id}`);
  }
}
